import React from "react";

import ResumeBarSigned from "./HomeComponents/Resume/ResumeBarSigned";
import CasaRuufImage from "./HomeComponents/Images/CasaRuuf.png";
import { HomeGreeting } from "../../styles/texts";

import {
  UserData,
  UserBooking,
  SpecificBooking,
  UserContract,
} from "../../types/responseTypes";

interface HomeSignedProps {
  userData: UserData;
  userBooking: UserBooking;
  specificBooking: SpecificBooking;
  userContract?: UserContract | null;
}

const HomeSigned: React.FC<HomeSignedProps> = ({
  userData,
  userBooking,
  specificBooking,
  userContract,
}) => {
  console.log("HomeSigned", userData, userBooking, specificBooking, userContract);
  return (
    <div>
      <div className="flex flex-col items-center justify-center mb-10">
        <HomeGreeting userData={userData} userBooking={userBooking} />
        <img
          src={CasaRuufImage}
          alt="Casa Ruuf"
          className="w-1/8 md:w-1/8 mb-4"
        />

        {/* Para desarrollo local es util esto hee hee
        <div className="text-3xl font-bold text-gray-800 mb-4">
          Home Signed
        </div>
        */}

        <div className="w-full max-w-xl md:max-w-2xl p-4 rounded-lg bg-white shadow-lg">
          <ResumeBarSigned specificBooking={specificBooking} userContract={userContract}  />
        </div>
      </div>
    </div>
  );
};

export default HomeSigned;
